import {
  resolveOrgxAuth,
  type OrgxAuthSource,
  type ResolveOrgxAuthOptions,
} from "./auth.js";
import { getCurrentWorkspace, type OrgxWorkspace } from "./workspaces.js";

export interface WorkspaceConnectivityCheck {
  configured: boolean;
  ok: boolean;
  skipped: boolean;
  source: OrgxAuthSource | "none";
  baseUrl?: string;
  workspace?: OrgxWorkspace;
  error?: string;
  details: string[];
}

export async function checkWorkspaceConnectivity(
  options: ResolveOrgxAuthOptions = {},
): Promise<WorkspaceConnectivityCheck> {
  const auth = await resolveOrgxAuth(options);
  if (!auth) {
    return {
      configured: false,
      ok: false,
      skipped: true,
      source: "none",
      error: "No OrgX API key configured; workspace connectivity check skipped.",
      details: [],
    };
  }

  try {
    const workspace = await getCurrentWorkspace(options);
    if (!workspace) {
      return {
        configured: true,
        ok: false,
        skipped: false,
        source: auth.source,
        baseUrl: auth.baseUrl,
        error: "OrgX auth resolved, but no accessible workspace was returned.",
        details: [],
      };
    }

    return {
      configured: true,
      ok: true,
      skipped: false,
      source: auth.source,
      baseUrl: auth.baseUrl,
      workspace,
      details: [
        `workspace id: ${workspace.id}`,
        ...(workspace.isDefault ? ["workspace is marked as default"] : []),
      ],
    };
  } catch (error) {
    return {
      configured: true,
      ok: false,
      skipped: false,
      source: auth.source,
      baseUrl: auth.baseUrl,
      error: error instanceof Error ? error.message : String(error),
      details: [],
    };
  }
}
